import { render, staticRenderFns } from "./addCourseCtrBj.vue?vue&type=template&id=77e7e8d7&scoped=true"
import script from "./addCourseCtrBj.vue?vue&type=script&lang=js"
export * from "./addCourseCtrBj.vue?vue&type=script&lang=js"
import style0 from "./addCourseCtrBj.vue?vue&type=style&index=0&id=77e7e8d7&prod&lang=less"
import style1 from "./addCourseCtrBj.vue?vue&type=style&index=1&id=77e7e8d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e7e8d7",
  null
  
)

export default component.exports